import jwt from '../../http/requests/auth/jwt/index.js';
import 'firebase/auth';
import router from '@/router';
import axios from '@/axios';

export default {
  // JWT
  loginJWT(_context, payload) {
    return new Promise((resolve, reject) => {
      jwt
        .login(payload.userDetails.email, payload.userDetails.password)
        .then(response => {
          // If there's user data in response
          if (response.data) {
            resolve(response);
          } else {
            reject({ message: response.data.msg });
          }
        })
        .catch(({ response }) => {
          reject({ message: response.data.msg });
        });
    });
  },
  registerUserJWT(_context, payload) {
    return new Promise((resolve, reject) => {
      jwt
        .registerFranchise(payload.userDetails)
        .then(response => {
          // Redirect User
          router.push(router.currentRoute.query.to || '/');
          // Update data in localStorage
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  checkEmail(_context, email) {
    return new Promise((resolve, reject) => {
      jwt
        .checkEmailAvailability(email)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  registerFranchiseNurse(_context, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/v1/nurses/nurse/register', payload.userDetails)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getFranchiseDashboardData() {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/franchises/dashboardData')
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  fetchFranchise(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          '/api/v1/admins/franchiseList?page=' +
            data.page +
            '&limit=' +
            data.limit +
            '&search=' +
            data.search +
            '&sort=' +
            data.sort +
            '&dir=' +
            data.dir +
            '&filter=' +
            data.filter +
            '&activeClinicId=' +
            data.activeClinicId
        )
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  createFranchise(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/v1/admins/franchise/create', data)
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchFranchiseDetail(_context, id) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/admins/franchise/' + id)
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  updateFranchiseDetail(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/v1/admins/franchise/' + data.id + '/edit', data.data)
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  resetFranchisePassword(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          '/api/v1/admins/franchise/' + data.id + '/resetPassword',
          data.data
        )
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  deleteFranchise(_context, id) {
    return new Promise((resolve, reject) => {
      axios
        .delete('/api/v1/admins/franchise/' + id)
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },

  inviteUser(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/v1/franchises/sendUserInvitation', data)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  fetchClinics(_context, type) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/franchises/fetchClinics', { params: type })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  assignClinics(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/v1/franchises/assignClinics', data)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchAssignClinics(_context, nurseId) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/franchises/fetchAssignClinicsList', { params: nurseId })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  sendRequest(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/v1/franchises/sendRequestForAssociation', data)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  /* Franchise Admin Management */
  createFranchiseAdmin(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/v1/franchises/createFranchiseAdmin', data)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchFranchiseAdmin(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/franchises/fetchFranchiseAdmin', { params: data })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  fetchFranchiseAdminDetail(_context, id) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/franchises/fetchFranchiseAdminDetail/' + id)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  updateFranchiseAdmin(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .put(
          '/api/v1/franchises/updateFranchiseAdmin/' + data.franchiseId,
          data.franchiseData
        )
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  deleteSubFranchise(_context, id) {
    return new Promise((resolve, reject) => {
      axios
        .delete('/api/v1/franchises/deleteFranchiseAdmin/' + id)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  getExistingDoctorRate() {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/franchises/getExistingDoctorRate')
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  },
  saveDoctorRate(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/v1/franchises/saveDoctorRate', data)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  },
  fetchTreatmentAreas(_context, dataTableParams) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/franchises/applicableAreas', { params: dataTableParams })
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  },
  changeTreatmentAreaStatus(_context, payload) {
    return new Promise((resolve, reject) => {
      axios
        .patch('/api/v1/franchises/applicableAreas/changeStatus', payload)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  },
  fetchProductsList(_context, dataTableParams) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/franchises/productsList', { params: dataTableParams })
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  },
  changeProductStatus(_context, payload) {
    return new Promise((resolve, reject) => {
      axios
        .patch('/api/v1/franchises/productsList/changeStatus', payload)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  },
};
